
const state = {
    basicInfo:localStorage.getItem('flow') ? JSON.parse(localStorage.getItem('flow')).basicInfo : {},
  }
  const mutations = {
    changeValue: (state, obj) => { 
      localStorage.setItem('flow', JSON.stringify({'basicInfo':obj}))
    },
  }
  const actions = {
    changeValue: (state, obj) => { 
      console.log(obj)
      localStorage.setItem('flow', JSON.stringify({'basicInfo':obj}))
    },
  }
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/flow.js